module.exports = __webpack_public_path__ + "media/images/photo/top/plan/plan6-fc379b882164bdefeb6c9334e81a77af.jpg";